var uiKit = {
  datepicker: {
    sunday: 'Sonntag',
    monday: 'Montag',
    tuesday: 'Dienstag',
    wednesday: 'Mittwoch',
    thursday: 'Donnerstag',
    friday: 'Freitag',
    saturday: 'Samstag',
    sunday_short: 'SO',
    monday_short: 'MO',
    tuesday_short: 'DI',
    wednesday_short: 'MI',
    thursday_short: 'DO',
    friday_short: 'FR',
    saturday_short: 'SA',
    january: 'Jänner',
    february: 'Februar',
    march: 'März',
    april: 'April',
    may: 'Mai',
    june: 'Juni',
    july: 'Juli',
    august: 'August',
    september: 'September',
    october: 'Oktober',
    november: 'November',
    december: 'Dezember',
    pick_year: 'Wählen Sie ein Jahr',
    pick_month: 'Wählen Sie ein Monat',
    pick_date: 'Wählen Sie einen Tag'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'Hallo',
      lastLogin: 'Letzter Login',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'ID'
    },
    navigationMenu: {
      title: {
        myBets: 'Meine Wetten',
        accountHistory: 'Kontohistorie',
        withdraw: 'Auszahlung',
        reversalWithdraw: 'Auszahlung widerrufen',
        myRewards: 'Promos',
        myAccount: 'Mein Konto',
        depositLimit: 'Einzahlungslimit',
        deposit: 'Einzahlung',
        gamblingControls: 'Spiel-Kontrolle',
        saferGambling: 'Sicheres Spielen',
        pokerBalanceTransfer: 'Guthaben-Transfer'
      }
    },
    profitAndLoss: {
      title: 'Profit und Verlust',
      description: {
        up: 'Sie sind {{value}} im Plus',
        down: 'Sie sind {{value}} im Minus'
      }
    },
    saferGamblingHighlighted: {
      text: 'Bleiben Sie auf dem Laufenden. Nutzen Sie unsere Spiel-Kontrolle-Hilfsmittel, um sicher zu spielen und mehr über ' + '{{linkText}} zu erfahren.',
      linkText: 'safer gambling'
    },

    myAccountTitles: {
      title: {
        accountHistory: 'Kontohistorie',
        personalDetails: 'Persönliche Daten',
        loginSecuritySettings: 'Login & Sicherheitseinstellungen',
        siteSettings: 'Seiteneinstellungen'
      },
      listItems: {
        statementsView: 'Statement anzeigen',
        summaries: 'Nettoeinzahlungsinformationen',
        contactName: 'Kontaktname',
        contactDetails: 'Kontaktdaten',
        marketingPreferences: 'Marketing Präferenzen',
        autoLogin: 'Auto-Login',
        twoFactorAuth: 'Zwei-Faktor-Authentifizierung',
        password: 'Passwort',
        oddsFormat: 'Quotenformat'
      }
    },

    saferGambling: {
      tilesConfig: {
        header: {
          text: 'Das Glücksspiel sollte immer Spaß machen. Deshalb haben wir einige nützliche Tools erstellt, mit denen Sie die Kontrolle darüber behalten, wie viel Sie ausgeben.'
        },

        footer: {
          text: 'Erfahren Sie mehr darüber, was wir zur Unterstützung tun ',
          link: 'Sicheres Spielen'
        },

        selfAssessment: {
          title: 'Selbsteinschätzung',
          description: 'Verwenden Sie dieses Selbsteinschätzungstool, um Ihre Spielgewohnheiten im Auge zu behalten. Es dauert nur 2 Minuten!'
        },
        depositLimits: {
          title: 'Einzahlungslimits',
          description: 'Setzen Sie sich ein tägliches, wöchentliches oder monatliches Einzahlungslimit, das den Gesamtbetrag einschränkt, den Sie in dem bestimmten Zeitraum einzahlen können.'
        },

        gamingTimeReminder: {
          title: 'Spielzeit-Erinnerung',
          description: 'Nur für Gaming-Produkte verfügbar. Schalten Sie Benachrichtigungen ein, die Ihnen mitteilen, wie lange Sie schon spielen.'
        },

        timeOut: {
          title: 'Auszeit',
          descriptionUk: 'Machen Sie eine Pause vom Spielen. Es kann bis zu 42 Tage sein.',
          descriptionNonUk: 'Machen Sie eine Auszeit vom Spielen mit uns. Es kann alles bis zu 6 Monaten sein.'
        },

        accountClosure: {
          title: 'Kontoschließung',
          description: 'Es tut uns leid, dass Sie uns verlassen möchten, aber wenn Sie Ihr Konto schließen möchten, können Sie dies hier tun.'
        },

        selfExclusion: {
          title: 'Selbstausschluss',
          description: 'Schließen Sie Ihr Konto für sechs Monate bis fünf Jahre.'
        },
        profitAndLoss: {
          title: 'Profit und Verlust',
          description: {
            up: 'Sie sind {{value}} im Plus',
            down: 'Sie sind {{value}} im Minus'
          }
        }
      },

      views: {
        depositLimits: {
          day: 'Tag',
          week: 'Woche',
          month: 'Monat',
          viewHeader: {
            title: 'Setzen Sie sich ein Einzahlungslimit',
            content: 'Setzen Sie sich ein tägliches, wöchentliches oder monatliches Einzahlungslimit, das den Gesamtbetrag einschränkt, den Sie in dem bestimmten Zeitraum einzahlen können.<br>' + ' <a href="https://williamhill-de.custhelp.com/app/answers/detail/a_id/7024#2" rel="noopener noreferrer" target="_blank">Wie funktioniert es?</a>'
          },
          limits: {
            daily: 'Tägliches Einzahlungslimit',
            weekly: 'Wöchentliches Einzahlungslimit',
            monthly: 'Monatliches Einzahlungslimit'
          },
          periods: {
            day: 'tägliches',
            week: 'wöchentliches',
            month: 'monatliches'
          },
          buttonText: 'Speichern Sie Ihre Einzahlungslimits',
          chooseLimit: 'Wählen Sie Ihr Einzahlungslimit',
          valueNotSet: 'Nicht eingestellt',
          noLimit: 'Kein Einzahlungslimit',
          noLimitSet: 'Kein Einzahlungslimit gesetzt',
          remainingDeposit: {
            day: 'Sie haben noch {{amount}} übrig, um diesen Tag einzuzahlen.',
            week: 'Sie haben noch {{amount}} übrig, um diesen Woche einzuzahlen.',
            month: 'Sie haben noch {{amount}} übrig, um diesen Monat einzuzahlen.'
          },
          emptyRemainingDeposit: 'Sie haben keine Einzahlungslimits',
          successMessage: 'Einzahlungslimits erfolgreich aktualisiert',
          confirmationButton: 'Bestätigen Sie die Erhöhung des Einzahlungslimits auf {{amount}}',
          confirmationButtonNoLimit: 'Bestätigen Sie die Erhöhung des Einzahlungslimits auf "kein Einzahlungslimit"',
          confirmationMessage: {
            day: 'Ihr tägliches Einzahlungslimit von {{amount}} kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>',
            week: 'Ihr wöchentliches Einzahlungslimit von {{amount}} kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>',
            month: 'Ihr monatliches Einzahlungslimit von {{amount}} kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>'
          },
          confirmationMessageNoLimit: {
            day: 'Ihr tägliches Einzahlungslimit von "kein Einzahlungslimit" kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>',
            week: 'Ihr wöchentliches Einzahlungslimit von "kein Einzahlungslimit" kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>',
            month: 'Ihr monatliches Einzahlungslimit von "kein Einzahlungslimit" kann am {{date}} um {{time}} (UK-Zeit) bestätigt werden.<br><br>' + 'Sie können diese stornieren, indem Sie <a href=#">hier klicken</a>'
          },
          confirmationSuccessful: 'Einzahlungslimit erfolgreich aktualisiert',
          increaseWarning: 'Sie müssen es nach 24 Stunden bestätigen, falls Sie Ihr Einzahlungslimit erhöhen möchten.',
          footerContent: 'Sie sehen das Einzahlungslimit nicht, das Sie sich setzen möchten?<br/> ' + '<a href="https://williamhill-de.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">Kontaktieren Sie unseren Kundendienst</a>',
          cancellationModalContent: 'Sind Sie sich sicher, dass Sie die Erhöhung Ihres Einzahlungslimits stornieren möchten?'
        },

        gamingTimeReminder: {
          accordionText: 'Spielzeit-Erinnerung',
          currentReminder: 'Aktuelle Spielzeit-Erinnerung:',
          reminders: {
            placeholder: 'Wählen Sie die Zeitspanne aus',
            noReminder: 'Keine Spielzeit-Erinnerung',
            minutes: '{{time}} Minuten',
            hour: '{{time}} Stunde',
            hours: '{{time}} Stunden'
          },
          submitButton: 'Speichern Sie Ihre Spielzeit-Erinnerung',
          warningMessage: 'Die Zeiterinnerung wird wirksam werden, wenn Ihre aktuelle Sitzungserinnerung abgeschlossen ist oder die aktiven Spiele geschlossen sind.',
          successMessage: 'Spielzeit-Erinnerung erfolgreich aktualisiert',
          viewHeader: {
            title: 'Setzen Sie sich eine Spielzeit-Erinnerung',
            content: '<p>Setzen Sie sich eine automatische Spielzeit-Erinnerung, mit der Sie wissen, wie lange Sie schon spielen. </p><a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/3512/#3" rel="noopener noreferrer" target="_blank"> Wie funktioniert es?</a></br></br>' + '<p>Dies ist nur für Gaming-Produkte verfügbar. Bitte beachten Sie, dass Gaming-Produkte keine Sport-, Poker-, virtuellen oder Freispiel-Turniere enthalten. Um eine Erinnerung für Evolution Gaming-Inhalte festzulegen, starten Sie ein Spiel, wählen Sie "Einstellungen" und dann "Spielesitzungseinstellungen".</p>'
          },
          valueNotSet: 'Nicht eingestellt'
        },

        timeOut: {
          viewHeader: {
            title: 'Setzen Sie sich eine Auszeit',
            contentUk: 'Wenn Sie eine Pause vom Wetten machen möchten. Wir können eine Auszeit von bis zu 42 Tagen einrichten.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/3512/" rel="noopener noreferrer" target="_blank">Wie funktioniert es?</a>',
            contentNonUk: 'Wenn Sie eine Pause von Wetten bei uns machen möchten. Wir können eine Auszeit von bis zu 6 Monaten einrichten.</br>' + '<a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/3512/" rel="noopener noreferrer" target="_blank">Wie funktioniert es?</a>'
          },
          formLabel: 'Für wie lange möchten Sie diese?',
          values: {
            placeholder: 'Wählen Sie die Dauer der Auszeit aus',
            day: '1 Tag',
            days: '{{amount}} Tage',
            valueNotSet: 'Keine Auszeit'
          },
          formHeader: 'Schließen Sie Ihr Konto',
          passwordPlaceholder: 'Geben Sie Ihr Passwort ein',
          submitButton: 'Speichern Sie Ihre Auszeit',
          viewFooter: 'Wenn Sie eine Auszeit von mehr als 30 Tagen beantragen möchten, wenden Sie sich bitte <a href="https://williamhill-de.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">an unseren Kundendienst</a>',
          resultPage: {
            title: 'Ihr Konto nimmt eine  Auszeit',
            information: 'Sie können für {{period}} Tag (e) nicht auf Ihr Konto zugreifen.',
            helpSectionMainText: 'Um eine angemessene Pause einzulegen, sollten Sie auch alle Wett-Apps von Ihrem Telefon entfernen. Weitere Information finden Sie auf unserer Hilfeseite unter verantwortungsvolles Spielen.'
          }
        },

        accountClosure: {
          header: 'Ja, ich möchte mein Konto schließen.',
          listTitle: 'Folgendes müssen Sie zu wissen:',
          firstListElement: 'Wenn Sie aus Gründen zum verantwortungsvollen Spielen eine Pause einlegen oder Ihr Konto schließen möchten, ziehen Sie bitte eine <a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/3512/" rel="noopener noreferrer" target="_blank">Auszeit</a> (bis zu 6 Wochen) oder einen <a href="https://williamhill-de.custhelp.com/app/answers/detail/a_id/3512/#3" rel="noopener noreferrer" target="_blank">Selbstausschluss</a> (bis zu fünf Jahre) in Betracht',
          secondListElement: 'Stellen Sie sicher, dass Sie zuerst das verbleibende Guthaben in Ihrem Konto abheben',
          thirdListElement: 'Bitte beachten Sie, dass wir Ihre Daten für mindestens 5 Jahre aufbewahren werden. Weitere Information finden Sie in unserer <a href ="https://williamhill-de.custhelp.com/app/answers/detail/a_id/6967" rel="noopener noreferrer" target="_blank">Datenschutzrichtlinie</a> für weitere Informationen',
          formHeader: 'Schießen Sie Ihr Konto',
          closureReasonPlaceholder: 'Wählen Sie Ihren Grund aus',
          passwordPlaceholder: 'Tragen Sie Ihr Passwort ein',
          submitButton: 'Schließen Sie mein Konto',
          reasons: {
            CLOSURE_REASON_OFFERS: 'Ich bin mit Ihren Angeboten nicht zufrieden',
            CLOSURE_REASON_PRODUCTS: 'Ich bin mit Ihren Produkten nicht zufrieden',
            CLOSURE_REASON_SERVICE: 'Ich bin mit Ihrem Service nicht zufrieden',
            CLOSURE_REASON_TIME: 'Ich habe nicht mehr genug Zeit, um mein Konto zu nutzen',
            CLOSURE_REASON_CHANGES: 'Ich mag die Änderungen, die Sie kürzlich vorgenommen haben, nicht',
            CLOSURE_REASON_PROVIDER: 'Ich benutze jetzt einen anderen Anbieter',
            CLOSURE_REASON_SECRET: 'Ich würde es vorziehen, es nicht mitzuteilen'
          }
        },

        accountClosed: {
          title: 'Ihr Konto ist geschlossen worden.',
          text: 'Um eine Auszahlung anzufordern,<br>' + '<a href="https://williamhill-de.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank"> wenden Sie sich an unseren Kundendienst</a><br><br>' + 'Eine Wiedereröffnung Ihres Kontos ist jeder Zeit über unsere Kontowiederherstellungsseite möglich.',
          helpSectionMainText: 'Wenn Sie aus Gründen zum Verantwortvollungsvollen Spielen eine Pause einlegen oder Ihr Konto schließen möchten, ziehen Sie bitte eine Auszeit (bis zu 6 Wochen) oder einen Selbstausschluss (bis zu fünf Jahren) in Betracht.<br><br>' + 'Weitere Information finden Sie auf unserer Hilfeseite unter Verantwortungsvolles Spielen.'
        },

        gamblingHelpSection: {
          bottomSectionTitle: 'Weitere Hilfe',
          bottomSectionText: 'Es gibt Organisationen, die Ihnen mit kostenloser, unabhängiger Beratung zum Umgang mit Ihrem Glücksspiel helfen können.',
          mainButtonText: 'Gehe zu Safer Gambling',
          bottomSectionFirstButton: 'GamCare',
          bottomSectionSecondButton: 'Gamblers Anonymous',
          bottomSectionThirdButton: 'Glücksspieltherapie',
          gamstopHeader: 'GAMSTOP',
          gamstopContent: 'Wir empfehlen Ihnen dringend, alle mobilen Glücksspiel-Apps von William Hill und anderen Glücksspielanbietern zu deinstallieren. Sie können beantragen, von anderen in Großbritannien bei GAMSTOP registrierten Glücksspielseiten ausgeschlossen zu werden.',
          gamstopButton: 'Gehe zu GAMSTOP'
        },

        selfExclusionSelection: {
          viewHeader: {
            title: 'Beantragen Sie einen Selbstausschluss',
            content: 'Wenn Sie glauben, dass Sie ein Problem haben könnten und Sie sich vollständig vom Glücksspiel ausschließen möchten, empfehlen wir die Verwendung von GAMSTOP.<br /><br />GAMSTOP hilft Ihnen, Ihr Glücksspiel zu kontrollieren, indem es Sie für einen Zeitraum Ihrer Wahl von lizenzierten Glücksspielseiten und Apps in Großbritannien ausschließt.<br /><br />Sie können sich selbst für mindestens 6 Monate und bis zu 5 Jahre ausschließen.'
          },
          gamstopButton: 'Gehen Sie GAMSTOP',
          selfExcludeFromWH: 'Wählen Sie Selbstausschluss von William Hill'
        },

        selfExclusion: {
          viewHeader: {
            title: 'Beantragen Sie einen Selbstausschluss',
            content: 'Wir können Sie von unseren Dienstleistungen ausschließen und verhindern, dass Sie für mindestens 6 Monate und bis zu fünf Jahre auf unsere Produkte zugreifen.<br>' + '<a href="https://williamhill-de.custhelp.com/app/answers/detail/a_id/3512" rel="noopener noreferrer" target="_blank">Wie funktioniert es?</a><br/><br/> ' + '<p>Diese Aktion kann unter keinen Umständen rückgängig gemacht werden, bis der ausgewählte Selbstausschlusszeitraum abgelaufen ist.</p>'
          },
          upperSectionLabel: 'Sind Sie sicher, dass Sie einen Selbstausschluss wünschen?',
          termsMessage: 'Bei der Bitte, von William Hill ausgeschlossen zu werden, akzeptieren Sie die {{termsMessageLink}}.<br /><br />' + 'Sie werden für den von Ihnen beantragten Zeitraum keinen Zugang zu Ihrem Konto haben und können dieses auch nicht vor diesem Zeitraum wieder öffnen.',
          termsMessageLink: 'Nutzungsbedingungen', // please notice this is a part of the previous key
          formLabel: 'Für wie lange möchten Sie diese?',
          upperButton: 'Ja, ich möchte einen Selbstausschluss',
          period: {
            months: '{{amount}} Monate',
            year: '1 Jahr',
            years: '{{amount}} Jahre',
            valueNotSet: 'Kein Selbstausschlusszeitraum',
            indefinite: 'Unbestimmt (min. 1 Jahr)'
          },
          exclusionPeriodPlaceholder: 'Selbstausschlusszeitraum auswählen',
          passwordPlaceholder: 'Passwort eingeben',
          submitButton: 'Selbstausschluss beantragen',
          brandsNote: {
            text: 'Ihre Ausschlussvereinbarung mit William Hill <span style="font-weight: bold;">wird nicht</span> automatisch auf ein Konto angewendet, das Sie möglicherweise bei „888 Brands“ haben. Bei Bedarf müssen Sie also separat eine neue Vereinbarung mit ihnen treffen.',
            link888: 'Selbst ausschließen von 888.com',
            link777: 'Selbst ausschließen von 777.com'
          }
        },

        termsAndConditions: {
          text: 'Dieses Dokument bestätigt die freiwillige Vereinbarung zwischen dem Kunden und WHG (International) Limited über den Selbstausschluss des Kunden von seinen Internet- und Telefonwetten.<br><br><br>' + 'Der Kunde beantragt, dass sein Konto geschlossen wird und dass ihm die Wett- und Spielaktivitäten über  Telefon- und Internet-Wett- oder Spielbetrieb der WHG (International) Limited Unternehmensgruppe für den ausgewählten Zeitraum, ab dem beantragten Datum verweigert werden, nach Erhalt der Bestätigung der Kundenanfrage bei WHG (International) Limited und dass er / sie seinen / ihren Selbstausschluss vor Ablauf dieser Vereinbarung nicht ändern, widerrufen, zurückziehen oder aufheben darf.<br><br><br>' + 'Hinweis: Der Ausschluss vom Internetbetrieb erfolgt unter Bezugnahme auf die Kontonummer und die E-Mail-Adresse und der Ausschluss vom Telefonbetrieb unter Bezugnahme auf die Kontonummer. Wir werden ebenfalls angemessene Schritte unternehmen, um etwaige Kredit– und Debit Karten von der Benutzung auszuschließen. Wir empfehlen Kunden dringend, alle mit William Hill verbundenen Apps oder Anwendungen von ihren Geräten zu löschen / zu deinstallieren. <br><br><br>' + 'Am Ende des Selbstausschlusszeitraums oder jederzeit danach, kann dieser Selbstausschluss mit unserem Kundendienst überprüft und um einen anderen festgelegten Zeitraum verlängert werden oder Sie setzen das Glücksspiel fort. Auf Antrag, den Selbstausschluss nicht zu verlängern, unterliegen Sie einer weiteren eintägigen Ausschlussfrist, bevor Sie Zugriff zu Ihrem Konto haben und dieses nützen können.',
          button: 'Ich habe die Allgemeinen Geschäftsbedingungen gelesen'
        },

        selfExcluded: {
          title: 'Selbstauschluss ist nun auf Ihrem Konto aktiviert',
          subtitle: {
            months: 'Sie werden für {{amount}} Monate nicht auf Ihr Konto zugreifen können.',
            year: 'Sie werden für {{amount}} Jahr nicht auf Ihr Konto zugreifen können.',
            years: 'Sie werden für {{amount}} Jahre nicht auf Ihr Konto zugreifen können.',
            indefinite: 'Ihr Konto ist auf unbestimmte Zeit selbst ausgeschlossen, und Sie können mindestens 1 Jahr lang nicht auf Ihr Konto zugreifen.'
          },
          helpSectionMainText: 'Um eine richtige Pause einzulegen, denken Sie daran, alle anderen Glücksspielseiten oder Apps von Ihren Geräten zu entfernen. Ein etwaiges Restguthaben wird Ihnen automatisch erstattet. Weitere Informationen finden Sie auf unserer SaferGambling-Seite.'
        },

        divider: {
          or: 'ODER'
        }
      },

      valueNotSet: 'Nicht eingestellt',
      incorrectPasswordErrorMessage: 'Ihr Passwort stimmt nicht überein',
      genericError: 'Leider konnte Ihre Anfrage nicht abgeschlossen werden. Bitte versuchen Sie es erneut oder wenden Sie sich an den Kundendienst, um Unterstützung zu erhalten.'
    },

    header: {
      error: {
        message: 'Daten konnten nicht abgerufen werden',
        retry: 'Nochmal versuchen'
      },
      title: {
        accountNetDeposit: 'Nettoeinzahlungsinformationen',
        landing: 'Mein Konto',
        myAccount: 'Mein Konto',
        myBets: 'Meine Wetten',
        personalDetails: 'Persönliche Daten',
        siteSettings: 'Seiteneinstellungen',
        accountHistory: 'Kontohistorie',
        loginSecurity: 'Login & Sicherheitseinstellungen',
        summaryExport: 'Zusammenfassung exportieren',
        deposit: 'Einzahlung',
        saferGambling: 'Sicheres Spielen',
        depositLimitsPage: 'Einzahlungslimits',
        gamingTimeReminderPage: 'Spielzeit-Erinnerung',
        accountClosure: 'Kontoschließung',
        accountClosed: 'Kontoschließung',
        timeOutResult: 'Auszeit',
        timeOut: 'Auszeit',
        termsAndConditions: 'Selbstausschluss',
        selfExclusionSelectionPage: 'Selbstausschluss',
        selfExclusionPage: 'Selbstausschluss',
        selfExcluded: 'Selbstausschluss',
        bonusLanding: 'Kontostandinformation'
      }
    },
    balanceAndBonus: {
      cashBalance: 'Bargeldguthaben',
      additionalBalance: { sportsbook: 'Gratiswetten', gaming: 'Gaming Bonus' },
      balanceInfoLink: 'Kontostandinformationen'
    },
    bonusLanding: {
      withdrawable: {
        title: 'Auszahlbares Guthaben',
        balances: {
          mainCashBalance: {
            mainText: 'Bargeldguthaben',
            helperText: 'Kann überall verwendet werden, außer für Poker'
          }, //@deprecated, use sportsbook key instead
          pokerCashBalance: {
            mainText: 'Poker Bargeldguthaben',
            helperText: 'Kann ausschließlich für Poker genutzt werden'
          }, //@deprecated, use poker key instead
          sportsbook: { mainText: 'Bargeldguthaben', helperText: 'Kann überall verwendet werden, außer für Poker' },
          poker: { mainText: 'Poker Bargeldguthaben', helperText: 'Kann ausschliesslich für Poker genutzt werden' }
        }
      },
      bonus: {
        title: 'Bonusguthaben',
        balances: {
          gaming: {
            mainText: 'Gaming',
            helperText: 'Bonusguthaben für Gamin',
            buyInBalance: {
              mainText: 'Buy-in Guthaben',
              helperText: 'Guthaben, das an Boni gebunden ist'
            },
            bonusBalance: {
              mainText: 'Bonusguthaben',
              helperText: 'Bonus und ausstehendes Gewinnguthaben'
            }
          },
          sportsbook: {
            mainText: 'Sport Gratiswetten',
            helperText: 'Gratiswetten für Sportwetten'
          },
          bingo: { mainText: 'Bingo', helperText: 'Bonusguthaben für Bingo' },
          poker: { mainText: 'Poker', helperText: 'Bonusguthaben für Poker' }
        }
      },
      footerText: {
        gaming: 'Sehen Sie sich unsere Promotionen an, um zu sehen, welche anderen Gaming Boni verfügbar sind'
      },
      buttonText: { gaming: 'Gaming Promotionen ansehen' }
    },
    transactions: {
      reference: 'Ref. Nummer',
      aamsId: 'ID AAMS:',
      EW: 'EW',
      eachWay: ' EW1-{{places}} Platz, {{price}} Quote',
      stake: 'Einsatz',
      refund: 'Rückerstattung',
      return: 'Gewinn',
      bonusStake: 'Bonuseinsatz',
      stakeTotal: 'Gesamteinsatz',
      tab: {
        summary: 'Zusammenfassung',
        history: 'Transaktionen'
      },
      myBets: {
        open: 'Offen',
        settled: 'Ausgewertet'
      },
      numberOfLines: 'x {{value}} Wetten',
      price: {
        '@ SP': '@ SP',
        '@ Guaranteed Price': '@ Garantierte Quote ({{price}})'
      },
      accountNetDeposit: {
        buttonLabel: 'Sehen Sie Ihre',
        buttonTitle: 'Nettoeinzahlungsinformationen'
      },
      lotteryBet: {
        draw: 'Ziehung:',
        result: 'Resultat:'
      },
      totePoolBetting: 'Pool Wetten',
      bettingTerminal: 'Wett-Terminal',
      type: {
        BET_ACCUMULATOR_10: 'Kombi (10)',
        BET_ACCUMULATOR_11: 'Kombi (11)',
        BET_ACCUMULATOR_12: 'Kombi (12)',
        BET_ACCUMULATOR_13: 'Kombi (13)',
        BET_ACCUMULATOR_14: 'Kombi (14)',
        BET_ACCUMULATOR_15: 'Kombi (15)',
        BET_ACCUMULATOR_16: 'Kombi (16)',
        BET_ACCUMULATOR_17: 'Kombi (17)',
        BET_ACCUMULATOR_18: 'Kombi (18)',
        BET_ACCUMULATOR_19: 'Kombi (19)',
        BET_ACCUMULATOR_20: 'Kombi (20)',
        BET_ACCUMULATOR_21: 'Kombi (21)',
        BET_ACCUMULATOR_22: 'Kombi (22)',
        BET_ACCUMULATOR_23: 'Kombi (23)',
        BET_ACCUMULATOR_24: 'Kombi (24)',
        BET_ACCUMULATOR_25: 'Kombi (25)',
        BET_ACCUMULATOR_4: '4er Kombi',
        BET_ACCUMULATOR_5: '5er-Kombi',
        BET_ACCUMULATOR_6: '6er-Kombi',
        BET_ACCUMULATOR_7: '7er-Kombi',
        BET_ACCUMULATOR_8: '8er-Kombi',
        BET_ACCUMULATOR_9: '9er-Kombi',
        BET_CANADIAN: 'Canadian',
        BET_DDB: 'Tote - Daily Double',
        BET_DOUBLE: '2er-Kombi',
        BET_DOUBLES: 'Doppel',
        BET_EIGHTFOLDS: '8er-Kombi',
        BET_EXA: 'Tote - Exacta',
        BET_FIVEFOLDS: '5er-Kombi',
        BET_FLG: 'Flag',
        BET_FOURFOLDS: '4er Kombi',
        BET_GOLIATH: 'Goliath',
        BET_HEINZ: 'Heinz',
        BET_LUCKY_15: 'Lucky 15',
        BET_LUCKY_31: 'Lucky 31',
        BET_LUCKY_63: 'Lucky 63',
        BET_MAN: 'Schriftliche Wette',
        BET_NINEFOLDS: '9er-Kombi',
        BET_PATENT: 'Patent',
        BET_PK3: 'Tote - Wähle 3',
        BET_PK4: 'Tote - Wähle 4',
        BET_PK6: 'Tote - Wähle 6',
        BET_PK9: 'Tote - Wähle 9',
        BET_PLC: 'Tote - Platzieren',
        BET_QIN: 'Tote - Quinella',
        BET_ROB: 'Round Robin',
        BET_SEVENFOLDS: '7er-Kombi',
        BET_SHW: 'Tote - Anzeigen',
        BET_SINGLE: 'Einzel',
        BET_SIXFOLDS: '6er-Kombi',
        BET_SPR: 'Tote - Superfecta',
        BET_SUPER_HEINZ: 'Super Heinz',
        BET_TENFOLDS: 'Kombi (10)',
        BET_TREBLE: '3er-Kombi',
        BET_TREBLES: 'Tripel',
        BET_TRI: 'Tote - Trifecta',
        BET_TRIXIE: 'Trixie',
        BET_UEXA: 'Tote - Exacta',
        BET_UJKP: 'Tote - Jackpot',
        BET_UKN: 'Wette',
        BET_UPLC: 'Tote - Platzieren',
        BET_UPLP: 'Tote - Placepot',
        BET_UQDP: 'Tote - Quadpot',
        BET_USC6: 'Tote - Scoop 6',
        BET_USC7: 'Tote - Super 7',
        BET_USW: 'Tote - Swinger',
        BET_UTD: 'Tote - Doppel',
        BET_UTRI: 'Tote - Trifecta',
        BET_UTT: 'Tote - Tripel',
        BET_UWIN: 'Tote - Win',
        BET_WIN: 'Tote - Win',
        BET_YANKEE: 'Yankee',
        BONUS: 'Guthaben Anpassung',
        DEPOSIT: 'Einzahlung',
        PRIORITY_CARD_CASH: 'Cash Out',
        PRIORITY_CARD_CASHBACK: 'Mit Cashback kaufen',
        PRIORITY_CARD_DEPOSIT: 'Einzahlung',
        PRIORITY_CARD_NON_CASH: 'Non-Cash',
        PRIORITY_CARD_OTHER: 'Andere',
        PRIORITY_CARD_PURCHASE: 'Kaufen',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-Cash',
        PRIORITY_CARD_REFUND: 'Vergütung',
        PRIORITY_CARD_TRANSACTION: 'Transaktion',
        REVERSAL: 'Stornierung',
        MANUAL_ADJUSTMENT: 'Manuelle Anpassung',
        WITHDRAWAL: 'Auszahlung',
        TRANSFER: 'Transfer',
        CASINO: 'Casino',
        SLOTS: 'Slots',
        VEGAS: 'Vegas',
        GAMES: 'Games',
        POKER: 'Poker',
        BINGO: 'Bingo',
        LIVE_CASINO: 'Live Casino'
      },
      manualAdjustmentType: {
        AFFP: 'Affiliate Zahlungen',
        AFFR: 'Affiliate Rakeback',
        BCNV: 'Guthaben konvertieren',
        BETC: 'Wett-Korrektur',
        BNJW: 'Jackpot Gewinne',
        BNKC: 'Bankgebühr',
        BONS: 'Manueller Bonus',
        BPCS: 'Bonuszahlung (cs)',
        BTCS: 'Guthabentransfer (cs)',
        CADJ: 'Provisionsanpassung',
        CSH: 'Bargeldanpassung',
        CWIN: 'Abgezogene Gewinne',
        GWCS: 'Geste des guten Willens (cs)',
        GWIL: 'Geste des guten Willens',
        HEDG: 'Absicherung',
        INAC: 'Inaktivitätsgebühr',
        ISCS: 'Inkorrekte Abschließung',
        LFND: 'Verlorene/Festsitzende Gelder',
        MCM: 'Manuelle Bargeldverschiebung',
        ONCR: 'On-Course',
        PGCW: 'Pre GC Abschreibung',
        RCHQ: 'Scheck zurückgeben',
        SCHQ: 'Scheck stoppen',
        TFCS: 'Festsitzende Gelder (cs)',
        WOFF: 'Abschreiben'
      },
      result: {
        WIN: 'Gewinn',
        LOST: 'Verlust',
        VOIDED: 'Ungültig',
        CASHED_IN: 'Ausgecasht',
        STAKE: 'Einsatz',
        CANCELED: 'Abgebrochen',
        PLACED: 'Platziert'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: 'Banktransfer',
        CARD: 'Kredit/Debit Karte',
        CHEQUE: 'Cheque',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: 'Direkte Banküberweisung',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'Andere',
        PAYPAL: 'PayPal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'Jederzeit',
        ANYTIME_WINCAST: 'Jederzeit Wincast',
        ASIAN_HANDICAP: 'Asian Handicap',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'Kombination erste 4',
        COMBINATION_FORECAST: 'Kombination Forecast',
        COMBINATION_QUINELLA: 'Kombination Quinella',
        COMBINATION_TRICAST: 'Kombination Tricast',
        CONTINUOUS_WIN: 'Kontinuierlicher Gewinn',
        FIRST_FOUR: 'Erste 4',
        FIRST_HALF_ASIAN_HANDICAP: '1. HZ Asian Handicap',
        FIRST_HALF_OUTRIGHT: '1. HZ Outright',
        FIRST_HALF_WESTERN_HANDICAP: '1. HZ Western Handicap',
        FIRST_WINCAST: 'Erster Wincast',
        FORECAST: 'Vorhersage',
        HIGHER_LOWER: 'Höher/Niedriger',
        HIGHER_LOWER_SPLIT_OFFER: 'Höher/Niedriger (mit Split Angebot)',
        INSURED_SCORECAST: 'Insured Scorecast',
        INSURED_WINCAST: 'Insured Wincast',
        LAST_SCORECAST: 'Letzter',
        LAST_WINCAST: 'Last Wincast',
        MATCH_HANDICAP: 'Handicap',
        OVER_UNDER: 'Über/Unter',
        PERMED_FORECAST: 'Dauervorhersage',
        PERMED_TRICAST: 'Dauertricast',
        POINTS_MARKET: 'Punkte',
        QUINELLA: 'Quinella',
        REVERSE_FORECAST: 'Vorhersage stornieren',
        SCORECAST: 'Torschütze',
        SECOND_HALF_ASIAN_HANDICAP: '2. HZ Asian Handicap',
        SECOND_HALF_OUTRIGHT: '2. HZ Outright',
        SECOND_HALF_WESTERN_HANDICAP: '2. HZ Western Handicap',
        SIMPLE: 'Einfach',
        STANDOUT_FIRST_FOUR: 'Standout erste 4',
        STANDOUT_FORECAST: 'Standout Forecast',
        STANDOUT_QUINELLA: 'Standout Quinella',
        STANDOUT_TRICAST: 'Standout Tricast',
        STRAIGHT_FORECAST: 'Straight Forecast',
        TRICAST: 'Tricast',
        TRICAST_OPTIONS: 'Tricast Optionen',
        WESTERN_HANDICAP: 'Western (straight) Handicap',
        XTH_SCORER_SCORECAST: 'X. Torschütze',
        XTH_SCORER_WINCAST: 'X. Torschütze und gewinnt'
      },
      boostedBet: 'Erhöhte Wette',
      loadMore: 'Mehr',
      noTransactions: 'Keine Transaktionen',
      resetFilters: {
        filtersApplied: 'Filter angewandt',
        removeFilters: 'Alle entfernen'
      },
      summary: {
        correctAsOfMidnight: 'Korrekt ab Mitternacht',
        lastRefresh: '{{day}} {{month}} {{year}}',
        profitLoss: 'Profit und Verlust',
        sports: 'Sportwetten',
        gaming: 'Gaming',
        profitLossBreakdown: 'Profit und Verlustaufschlüsselung',
        winsLosses: 'Gewinn - Verlust',
        netDeposit: 'Nettoeinzahlung',
        lifetimeNetDeposit: 'Insgesamte Nettoeinzahlungen',
        totalDepositsWithdrawals: 'Gesamtauszahlungen - Gesamteinzahlungen',
        netDepositAvailableFrom: 'Informationen erst ab dem 06.12.2008 verfügbar',
        saferGamblingNote: {
          title: 'Spielen Sie verantwortungsbewusst?',
          description: 'Stellen Sie sicher, dass Sie weiterhin Spaß beim Spielen haben und das ausgeben, was Sie sich leisten können. Wenn Sie dabei Hilfe benötigen, schauen Sie sich unsere {{link}} an.',
          link: 'Hilfsmittel für Sicheres Spielen'
        }
      }
    },
    filters: {
      dropdown: {
        transactionsSummary: {
          date: 'Diesen Monat',
          filters: 'Filter'
        },
        transactionsHistory: {
          date: 'Letzte 7 Tage',
          filters: 'Filter'
        }
      },
      customDateRange: {
        toLabel: 'Bis',
        labels: {
          from: 'Von',
          to: 'Bis'
        },
        error: 'Bitte geben Sie eine gültige Zeitspanne ein oder wählen Sie eine andere Option',
        historyLimitation: {
          caption: 'Bitte beachten Sie, dass Transaktionen, die älter als 1 Jahr sind, \
möglicherweise nicht verfügbar sind. Wenn Sie diese Transaktionen anzeigen möchten, wenden Sie sich bitte an ',
          link: 'den Kundendienst'
        }
      },
      predefinedDateRange: {
        sectionName: 'Voreingestellte Zeitspanne',
        allDates: 'Alle Daten',
        last7: 'Letzte 7 Tage',
        last14: 'Letzte 14 Tage',
        last30: 'Letzte 30 Tage',
        custom: 'Benutzerdefiniert'
      },
      transactionsSummaryDateRange: {
        sectionName: 'Datumsbereich auswählen',
        monthToDate: 'Diesen Monat',
        last7days: 'Letzte 7 Tage',
        last12months: 'Letzte 12 Monate'
      },
      view: {
        sectionName: 'Anzeigen',
        all: 'Alle',
        onlyPayments: 'Nur Transaktionen',
        excludePayments: 'Transaktionen exkludieren',
        onlyWins: 'Nur Gewinne',
        onlyLosses: 'Nur Verluste'
      },
      showHideBetTypes: {
        sectionName: 'Wetten anzeigen/verbergen',
        singles: 'Einzel',
        multiples: 'Kombi'
      },
      tabs: {
        all: 'Alle',
        sports: 'Sport',
        gaming: 'Gaming'
      },
      applyFilters: 'Anwenden'
    },
    footer: {
      button: {
        logout: {
          text: 'Ausloggen'
        }
      },
      link: {
        feedback: 'Feedback',
        help: 'Hilfe'
      }
    },
    oddsFormat: {
      title: 'Quotenformat',
      decimal: 'Dezimal',
      fractional: 'Fraktional'
    },
    personalDetails: {
      tabs: {
        contact: 'Kontakt',
        marketing: 'Marketing'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'Bei William Hill nehmen wir die Sicherheit und Privatsphäre Ihres Spielerkontos sehr ernst.',
        text: 'Ihre Kontaktdaten werden an einem sicheren Ort aufbewahrt. Die Kontaktdaten umfassen Ihren Namen, Ihre Adresse, Ihre Telefonnummer \
& Ihre Email Adresse. Um Ihre Daten zu ändern, füllen Sie bitte das untenstehende Formular aus und klicken Sie "Kontaktdaten aktualisieren". \
Ihre Daten werden in unserem System aktualisiert aber nicht auf unserer Seite angezeigt.'
      },
      statusMessage: {
        success: 'Kontaktdaten erfolgreich aktualisiert.',
        failure: 'Etwas ist schief gelaufen.'
      },
      fields: {
        email: {
          label: 'Email'
        },
        addressLine1: {
          label: 'Adresszeile 1'
        },
        addressLine2: {
          label: 'Adresszeile 2'
        },
        addressCity: {
          label: 'Stadt'
        },
        addressCounty: {
          label: 'Land/Staat (optional)'
        },
        addressPostcode: {
          label: 'Postleitzahl / ZIP'
        },
        country: {
          label: 'Land',
          defaultValue: 'Bitte wählen Sie aus der Liste.'
        },
        mobile: {
          label: 'Telefonnummer'
        }
      },
      buttons: {
        submit: 'Kontaktdaten aktualisieren'
      },
      validationRules: {
        email: {
          required: 'Die E-Mail Adresse darf nicht leer stehen.',
          maxLength: 'Zu lange. Maximal 60 Zeichen erlaubt.',
          email: 'Es muss eine gültige E-Mail Adresse sein.'
        },
        street1: {
          required: 'Die Adresse ist ein Pflichtfeld.',
          maxLength: 'Zu lange. Maximal 160 Zeichen erlaubt.',
          pattern: 'Ungültiges Zeichen'
        },
        street2: {
          required: 'Die Adresse ist ein Pflichtfeld.',
          maxLength: 'Zu lange. Maximal 160 Zeichen erlaubt.',
          pattern: 'Ungültiges Zeichen'
        },
        city: {
          required: 'Die Stadt ist ein Pflichtfeld.',
          pattern: 'Ungültiges Zeichen.',
          maxLength: 'Zu lange. Maximal 60 Zeichen erlaubt.'
        },
        county: {
          pattern: 'Ungültiges Zeichen.',
          maxLength: 'Zu lange. Maximal 60 Zeichen erlaubt.'
        },
        postcode: {
          required: 'Postleitzahl darf nicht leer stehen.',
          pattern: 'Ungültiges Zeichen.',
          maxLength: 'Zu lange. Maximal 12 Zeichen erlaubt.'
        },
        mobile: {
          required: 'Telefonnummer darf nicht leer stehen.',
          pattern: 'Ungültiges Zeichen. Nur Ziffern erlaubt.',
          minLength: 'Zu kurz. Mindestens 6 Zeichen erforderlich.',
          maxLength: 'Zu lange. Maximal 20 Zeichen erlaubt.'
        }
      }
    },
    personalDetailsTimezone: {
      statusMessage: {
        success: 'Zeitzone aktualisiert',
        failure: 'Etwas ist schief gelaufen'
      },
      buttons: {
        updateTimezone: 'Zeitzone aktualisieren'
      },
      fields: {
        timezones: {
          label: 'Zeitzonen',
          values: {
            TIMEZONE_AFRICA_ADDIS_ABABA: 'Afrika/Addis_Ababa',
            TIMEZONE_AFRICA_JOHANNESBURG: 'Afrika/Johannesburg',
            TIMEZONE_AMERICA_ANCHORAGE: 'Amerika/Anchorage',
            TIMEZONE_AMERICA_ARGENTINA_BUENOS_AIRES: 'Amerika/Argentinien/Buenos_Aires',
            TIMEZONE_AMERICA_CHICAGO: 'Amerika/Chicago',
            TIMEZONE_AMERICA_DENVER: 'Amerika/Denver',
            TIMEZONE_AMERICA_LOS_ANGELES: 'Amerika/Los_Angeles',
            TIMEZONE_AMERICA_NEW_YORK: 'Amerika/New_York',
            TIMEZONE_AMERICA_SAO_PAULO: 'Amerika/Sao_Paulo',
            TIMEZONE_AMERICA_TORONTO: 'Amerika/Toronto',
            TIMEZONE_AMERICA_VANCOUVER: 'Amerika/Vancouver',
            TIMEZONE_ASIA_BANGKOK: 'Asien/Bangkok',
            TIMEZONE_ASIA_DHAKA: 'Asien/Dhaka',
            TIMEZONE_ASIA_DUBAI: 'Asien/Dubai',
            TIMEZONE_ASIA_HONG_KONG: 'Asien/Hong_Kong',
            TIMEZONE_ASIA_JERUSALEM: 'Asien/Jerusalem',
            TIMEZONE_ASIA_KARACHI: 'Asien/Karachi',
            TIMEZONE_ASIA_KOLKATA: 'Asien/Kolkata',
            TIMEZONE_ASIA_RANGOON: 'Asien/Rangoon',
            TIMEZONE_ASIA_SINGAPORE: 'Asien/Singapur',
            TIMEZONE_ASIA_TOKYO: 'Asien/Tokyo',
            TIMEZONE_ATLANTIC_AZORES: 'Atlantic/Azores',
            TIMEZONE_ATLANTIC_BERMUDA: 'Atlantic/Bermuda',
            TIMEZONE_AUSTRALIA_ADELAIDE: 'Australia/Adelaide',
            TIMEZONE_AUSTRALIA_PERTH: 'Australia/Perth',
            TIMEZONE_AUSTRALIA_SYDNEY: 'Australia/Sydney',
            TIMEZONE_EUROPE_ATHENS: 'Europe/Athen',
            TIMEZONE_EUROPE_BERLIN: 'Europe/Berlin',
            TIMEZONE_EUROPE_DUBLIN: 'Europe/Dublin',
            TIMEZONE_EUROPE_GIBRALTAR: 'Europe/Gibraltar',
            TIMEZONE_EUROPE_KIEV: 'Europe/Kiew',
            TIMEZONE_EUROPE_LONDON: 'Europe/London',
            TIMEZONE_EUROPE_MADRID: 'Europe/Madrid',
            TIMEZONE_EUROPE_MOSCOW: 'Europe/Moskau',
            TIMEZONE_EUROPE_PARIS: 'Europe/Paris',
            TIMEZONE_EUROPE_ROME: 'Europe/Rom',
            TIMEZONE_EUROPE_SOFIA: 'Europe/Sofia',
            TIMEZONE_EUROPE_VIENNA: 'Europe/Wien',
            TIMEZONE_EUROPE_WARSAW: 'Europe/Warschau',
            TIMEZONE_INDIAN_CHRISTMAS: 'Indischer Ozean/Christmas',
            TIMEZONE_PACIFIC_AUCKLAND: 'Pazifik/Auckland',
            TIMEZONE_PACIFIC_GUADALCANAL: 'Pazifik/Guadalcanal',
            TIMEZONE_PACIFIC_HONOLULU: 'Pazifik/Honolulu',
            TIMEZONE_PACIFIC_MIDWAY: 'Pazifik/Midway'
          }
        }
      },
      validationRules: {
        required: 'Wählen Sie Ihre Zeitzone'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'Ich möchte Informationen bezüglich Angeboten und Updates via E-Mail, SMS oder Telefon erhalten. \
Sie können Ihre Präferenzen jederzeit ändern.',
      contactMethodLabel: {
        telephone: 'Anruf',
        email: 'E-Mail',
        sms: 'SMS'
      },
      error: {
        save: 'Wi bitten um Verzeihung. Ihre Daten können im Moment nicht gespeichert werden. Versuchen Sie es später bitte erneut.'
      },
      disclaimer: {
        text: 'Haftungsausschluss: ',
        note: 'Bitte beachten Sie, dass es bis zu 48 Stunden dauern kann, bis die Änderungen greifen. \
Wir nutzen Push Notifikationen als Teil unseres Service. Sie können die Nutzung in den Einstellungen ändern. \
Sollten Sie den Service auf mehr als einem Gerät nutzen, \
müssen Sie die Umstellungen auf jedem der Geräte durchführen.'
      }
    },
    loginSecurity: {
      changePassword: 'Passwort ändern',
      currentPassword: 'Aktuelles Passwort',
      newPassword: 'Neues Passwort',
      savePassword: 'Neues Passwort speichern',
      passwordUpdated: 'Ihr Passwort wurde aktualisiert',
      genericErrorMessage: 'Etwas ist schief gelaufen.',
      validationRules: {
        currentPassword: {
          required: 'Das aktuelle Passwortfeld ist leer.',
          invalidCredentials: 'Falsches Passwort'
        },
        newPassword: {
          required: 'Das neue Passwortfeld ist leer.',
          minLength: 'Das neue Passwort besteht aus weniger als 8 oder mehr als 15 Symbolen.',
          maxLength: 'Das neue Passwort besteht aus weniger als 8 oder mehr als 15 Symbolen.',
          hasDigit: 'Das neue Passwort enthält nicht die folgenden Elemente: eine Zahl, einen kleinen Buchstaben und eine Großbuchstabe.',
          hasUppercaseLetter: 'Das neue Passwort enthält nicht die folgenden Elemente: eine Zahl, einen kleinen Buchstaben und eine Großbuchstabe.',
          pattern: 'Das Passwort muss mindestens 8 Zeichen lang sein und muss mindestens einen Buchstaben, Zahl und ein Symbol (!#%&()*+,-./:<=>?@^_`|~) enthalten.',
          cannotBeEqualToLastPassword: 'Das neue Passwort kann nicht mit dem letzten Passwort identisch sein.'
        },
        genericRules: 'Verwenden Sie 8 bis 15 Zeichen. Das Passwort muss mindestens einen Buchstaben, eine Zahl und ein Symbol (!#%&()*+,./:<=>?@^_`|~) enthalten. Groß- und Kleinschreibung wird berücksichtigt. Keine Leerzeichen erlaubt.'
      }
    },
    accountNetDeposit: {
      title: 'Kontolaufzeit Nettoeinzahlungen',
      description: 'Der Nettoeinzahlungsbetrag zeigt die Summe aller Transaktionen Ihres Kontos (Auszahlungen abzüglich Einzahlungen).',
      accessNote: 'Bitte beachten Sie, dass wir nur auf Kontoinformationan ab dem 12.06.2008 zugreifen können',
      timePeriod: {
        title: 'Zeitperiode Nettoeinzahlung',
        description: 'Die Nettoeinzahlung für den ausgewählten Zeitraum. Alle Zeiträume beginnen mit dem vorherigen Tag. Wir senden diese Informationen innerhalb von 24 Stunden an Ihre registrierte E-Mail-Adresse.',
        optionsTitle: 'Wählen Sie einen Zeitraum',
        optionLabels: {
          LAST_DAY: 'Vorheriger Tag',
          LAST_WEEK: 'Vorherige 7 Tage',
          LAST_MONTH: 'Vorherige 30 Tage'
        },
        success: 'Wir senden diese Informationen innerhalb von 24 Stunden an Ihre registrierte E-Mail-Adresse',
        requestDeposit: 'Mailen Sie mir die ausgewählte Nettoeinzahlung'
      },
      lifetimeNetDepositButton: 'Kontolaufzeit Nettoeinzahlungen anzeigen'
    },
    error: {
      network: {
        text: 'Ein Netzwerkfehler ist aufgetreten.',
        subText: 'Bitte versuchen Sie es in ein paar Minuten erneut.',
        retrySubText: 'Bitte öffnen Sie "Mein Konto" in ein paar Minuten erneut.'
      },
      graphQL: {
        text: 'Wir konnten die angefragten Daten nicht finden.',
        subText: 'Bitte versuchen Sie es in ein paar Minuten erneut.',
        retrySubText: 'Bitte öffnen Sie "Mein Konto" in ein paar Minuten erneut.'
      },
      retry: 'Erneut versuchen',
      iconAlt: 'Traffic Cone'
    },
    confirmationModal: {
      confirmationText: 'Ja',
      cancellationText: 'Nein'
    }
  },
  countries: {
    COUNTRY_AD: 'Andorra',
    COUNTRY_AE: 'Vereinigte Arabische Emirate',
    COUNTRY_AF: 'Afghanistan',
    COUNTRY_AG: 'Antigua und Barbuda',
    COUNTRY_AI: 'Anguilla',
    COUNTRY_AL: 'Albanien',
    COUNTRY_AM: 'Armenien',
    COUNTRY_AN: 'Niederländische Antillen',
    COUNTRY_AO: 'Angola',
    COUNTRY_AQ: 'Antarktis',
    COUNTRY_AR: 'Argentinien',
    COUNTRY_AS: 'Amerikanisches Samoa',
    COUNTRY_AT: 'Österreich',
    COUNTRY_AU: 'Australien',
    COUNTRY_AW: 'Aruba',
    COUNTRY_AX: 'Aland Inseln',
    COUNTRY_AZ: 'Aserbaidschan',
    COUNTRY_BA: 'Bosnien Herzegovina',
    COUNTRY_BB: 'Barbados',
    COUNTRY_BC: 'British Kolumbia',
    COUNTRY_BD: 'Bangladesh',
    COUNTRY_BE: 'Belgien',
    COUNTRY_BF: 'Burkina Faso',
    COUNTRY_BG: 'Bulgarien',
    COUNTRY_BH: 'Bahrain',
    COUNTRY_BI: 'Burundi',
    COUNTRY_BJ: 'Benin',
    COUNTRY_BM: 'Bermuda',
    COUNTRY_BN: 'Brunei Darussalam',
    COUNTRY_BO: 'Bolivien',
    COUNTRY_BR: 'Brasilien',
    COUNTRY_BS: 'Bahamas',
    COUNTRY_BT: 'Bhutan',
    COUNTRY_BV: 'Bouvet Inseln',
    COUNTRY_BW: 'Botswana',
    COUNTRY_BY: 'Weißrussland',
    COUNTRY_BZ: 'Belize',
    COUNTRY_CA: 'Kanada',
    COUNTRY_CC: 'Kokos-Inseln',
    COUNTRY_CD: 'Republik Kongo',
    COUNTRY_CF: 'Zentralafrikanische Republik',
    COUNTRY_CG: 'Demokratische Republik Kongo',
    COUNTRY_CH: 'Schweiz',
    COUNTRY_CI: 'Elfenbeinküste',
    COUNTRY_CK: 'Cook Inseln',
    COUNTRY_CL: 'Chile',
    COUNTRY_CM: 'Kameroon',
    COUNTRY_CN: 'China',
    COUNTRY_CO: 'Kolumbien',
    COUNTRY_CR: 'Costa Rica',
    COUNTRY_CU: 'Kuba',
    COUNTRY_CV: 'Cape Verde Inseln',
    COUNTRY_CX: 'Weihnachtsinseln',
    COUNTRY_CY: 'Zypern',
    COUNTRY_CZ: 'Tscheschiche Republik',
    COUNTRY_DE: 'Deutschland',
    COUNTRY_DJ: 'Tschibuti',
    COUNTRY_DK: 'Dänemark',
    COUNTRY_DM: 'Dominica',
    COUNTRY_DO: 'Dominikanische Republik',
    COUNTRY_DZ: 'Algerien',
    COUNTRY_EC: 'Equador',
    COUNTRY_EE: 'Estland',
    COUNTRY_EG: 'Ägypten',
    COUNTRY_EH: 'Western Sahara',
    COUNTRY_ER: 'Entira',
    COUNTRY_ES: 'Spanien',
    COUNTRY_ET: 'Äthiopien',
    COUNTRY_EU: 'Europäische Union',
    COUNTRY_FI: 'Finnland',
    COUNTRY_FJ: 'Fiji',
    COUNTRY_FK: 'Kalkland Inseln',
    COUNTRY_FM: 'Mironesia',
    COUNTRY_FO: 'Farör Inseln',
    COUNTRY_FR: 'Frankreich',
    COUNTRY_FX: 'Metropolitan Frankreich',
    COUNTRY_GA: 'Gabun',
    COUNTRY_GD: 'Grenada',
    COUNTRY_GE: 'Georgien',
    COUNTRY_GF: 'French Guyana',
    COUNTRY_GG: 'Guernsey',
    COUNTRY_GH: 'Ghana',
    COUNTRY_GI: 'Gibraltar',
    COUNTRY_GL: 'Grönland',
    COUNTRY_GM: 'Gambia',
    COUNTRY_GN: 'Guinea',
    COUNTRY_GP: 'Guadeloupe',
    COUNTRY_GQ: 'Equatorial Guinea',
    COUNTRY_GR: 'Griechenland',
    COUNTRY_GS: 'Süd-Georgien',
    COUNTRY_GT: 'Guatemala',
    COUNTRY_GU: 'Guam',
    COUNTRY_GW: 'Guinea-Bissau',
    COUNTRY_GY: 'Guyana',
    COUNTRY_HK: 'Hong Kong',
    COUNTRY_HM: 'Herad und McDonald Inseln',
    COUNTRY_HN: 'Honduras',
    COUNTRY_HR: 'Kroatien',
    COUNTRY_HT: 'Haiti',
    COUNTRY_HU: 'Ungarn',
    COUNTRY_ID: 'Indonesien',
    COUNTRY_IE: 'Irland (Republik)',
    COUNTRY_IL: 'Israel',
    COUNTRY_IM: 'Isle of Man',
    COUNTRY_IN: 'Indien',
    COUNTRY_IO: 'British Indisches Ozenisches Territorium',
    COUNTRY_IQ: 'Irak',
    COUNTRY_IR: 'Iran',
    COUNTRY_IS: 'Island',
    COUNTRY_IT: 'Italien',
    COUNTRY_JE: 'Jersey',
    COUNTRY_JM: 'Jamaica',
    COUNTRY_JO: 'Jordanien',
    COUNTRY_JP: 'Japan',
    COUNTRY_KE: 'Kenia',
    COUNTRY_KG: 'Kyrgistan',
    COUNTRY_KH: 'Kambodscha',
    COUNTRY_KI: 'Kiribati',
    COUNTRY_KM: 'Comoros',
    COUNTRY_KN: 'Saints Kitts und Nevis',
    COUNTRY_KP: 'Korea (Nord)',
    COUNTRY_KR: 'Korea (Süd)',
    COUNTRY_KW: 'Kuwait',
    COUNTRY_KY: 'Cayman Inseln',
    COUNTRY_KZ: 'Kasachstan',
    COUNTRY_LA: 'Laos',
    COUNTRY_LB: 'Libanon',
    COUNTRY_LC: 'Saint Lucia',
    COUNTRY_LI: 'Lichtenstein',
    COUNTRY_LK: 'Sri Lanka',
    COUNTRY_LR: 'Liberia',
    COUNTRY_LS: 'Lesotho',
    COUNTRY_LT: 'Litauen',
    COUNTRY_LU: 'Luxenburg',
    COUNTRY_LV: 'Lettland',
    COUNTRY_LY: 'Libyen',
    COUNTRY_MA: 'Marokko',
    COUNTRY_MC: 'Monaco',
    COUNTRY_MD: 'Moldavien',
    COUNTRY_ME: 'Montenegro',
    COUNTRY_MG: 'Madagaskar',
    COUNTRY_MH: 'Marshalll Inseln',
    COUNTRY_MK: 'F. Y. Republik Mazedonien',
    COUNTRY_ML: 'Mali',
    COUNTRY_MM: 'Myanmar',
    COUNTRY_MN: 'Mongolei',
    COUNTRY_MO: 'Macao',
    COUNTRY_MP: 'Nördliche Marianen Inseln',
    COUNTRY_MQ: 'Martinique',
    COUNTRY_MR: 'Mauritanien',
    COUNTRY_MS: 'Montserrat',
    COUNTRY_MT: 'Malta',
    COUNTRY_MU: 'Mauritius',
    COUNTRY_MV: 'Malidiven',
    COUNTRY_MW: 'Malawi',
    COUNTRY_MX: 'Mexiko',
    COUNTRY_MY: 'Malaysien',
    COUNTRY_MZ: 'Mozambique',
    COUNTRY_NA: 'Namibia',
    COUNTRY_NC: 'Neu Caledonia',
    COUNTRY_NE: 'Niger',
    COUNTRY_NF: 'Norfolk Inseln',
    COUNTRY_NG: 'Nigeria',
    COUNTRY_NI: 'Nikaragua',
    COUNTRY_NL: 'Niederlande',
    COUNTRY_NO: 'Norwegen',
    COUNTRY_NP: 'Nepal',
    COUNTRY_NR: 'Nauru',
    COUNTRY_NU: 'Niue',
    COUNTRY_NZ: 'Neu Seeland',
    COUNTRY_OM: 'Oman',
    COUNTRY_PA: 'Panama',
    COUNTRY_PE: 'Peru',
    COUNTRY_PF: 'Französisch Polynesia',
    COUNTRY_PG: 'Papua Neuguinea',
    COUNTRY_PH: 'Philippinen',
    COUNTRY_PK: 'Pakistan',
    COUNTRY_PL: 'Polen',
    COUNTRY_PM: 'St. Pierre und Miquelon',
    COUNTRY_PN: 'Pitcairn',
    COUNTRY_PR: 'Puerto Rico',
    COUNTRY_PS: 'Palestinensisches Territorium',
    COUNTRY_PT: 'Portugal',
    COUNTRY_PW: 'Palau',
    COUNTRY_PY: 'Paraguay',
    COUNTRY_QA: 'Katar',
    COUNTRY_RE: 'Reunion',
    COUNTRY_RO: 'Romänien',
    COUNTRY_RS: 'Serbien',
    COUNTRY_RU: 'Russland',
    COUNTRY_RW: 'Rwanda',
    COUNTRY_SA: 'Saudi Arabien',
    COUNTRY_SB: 'Solomon Inseln',
    COUNTRY_SC: 'Seychellen',
    COUNTRY_SD: 'Sudan',
    COUNTRY_SE: 'Schweden',
    COUNTRY_SG: 'Singapur',
    COUNTRY_SH: 'St. Helena (Insel)',
    COUNTRY_SI: 'Slovenien',
    COUNTRY_SJ: 'Svalbard und Jan Mayen',
    COUNTRY_SK: 'Slowakai',
    COUNTRY_SL: 'Sierra Leone',
    COUNTRY_SM: 'San Marino',
    COUNTRY_SN: 'Senegal',
    COUNTRY_SO: 'Somalia',
    COUNTRY_SR: 'Suriname',
    COUNTRY_ST: 'Sao Tome und Principe',
    COUNTRY_SV: 'El Salvador',
    COUNTRY_SY: 'Syrien',
    COUNTRY_SZ: 'Swaziland',
    COUNTRY_TA: 'Tristan da Cunha',
    COUNTRY_TC: 'Turks und Caicos Inseln',
    COUNTRY_TD: 'Chad',
    COUNTRY_TF: 'French Süd Territorium',
    COUNTRY_TG: 'Togo',
    COUNTRY_TH: 'Thailand',
    COUNTRY_TJ: 'Tajikistan',
    COUNTRY_TK: 'Tokelau',
    COUNTRY_TM: 'Turkmenistan',
    COUNTRY_TN: 'Tunesien',
    COUNTRY_TO: 'Tonga',
    COUNTRY_TP: 'Ost Timor',
    COUNTRY_TR: 'Türkei',
    COUNTRY_TT: 'Trinidad Tobago',
    COUNTRY_TV: 'Tuvalu',
    COUNTRY_TW: 'Taiwan',
    COUNTRY_TZ: 'Tanzania',
    COUNTRY_UA: 'Ukraine',
    COUNTRY_UG: 'Uganda',
    COUNTRY_UK: 'Vereinigtes Königreich',
    COUNTRY_UM: 'United States minor outlying islands',
    COUNTRY_US: 'Vereinigte Staaten von Amerika',
    COUNTRY_UY: 'Uruguay',
    COUNTRY_UZ: 'Usbekistan',
    COUNTRY_VA: 'Vatikan City (Heiliger See)',
    COUNTRY_VC: 'St. Vincent und Grenadines',
    COUNTRY_VE: 'Venezuela',
    COUNTRY_VG: 'British Jungferninseln',
    COUNTRY_VI: 'Jungferninseln (USA)',
    COUNTRY_VN: 'Vietnam',
    COUNTRY_VU: 'Vanuatu',
    COUNTRY_WE: 'West Samoa',
    COUNTRY_WF: 'Wallis und Futuna Inseln',
    COUNTRY_WS: 'Samoa',
    COUNTRY_YE: 'Yemen',
    COUNTRY_YT: 'Mayotte',
    COUNTRY_ZA: 'Südafrika',
    COUNTRY_ZM: 'Zambia',
    COUNTRY_ZW: 'Zimbabwe'
  },
  'ui-kit': uiKit,
  date: {
    today: 'Heute',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    },
    monthsNumbered: {
      '01': uiKit.datepicker.january,
      '02': uiKit.datepicker.february,
      '03': uiKit.datepicker.march,
      '04': uiKit.datepicker.april,
      '05': uiKit.datepicker.may,
      '06': uiKit.datepicker.june,
      '07': uiKit.datepicker.july,
      '08': uiKit.datepicker.august,
      '09': uiKit.datepicker.september,
      10: uiKit.datepicker.october,
      11: uiKit.datepicker.november,
      12: uiKit.datepicker.december
    }
  }
};